define("settings/components/address-banner", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.showAddressBanner}}
    <Shared::CollapsableInfoCard
      @title={{html-safe
        (concat '<span class="u--text--md u--p__r__xs">⚠️</span>' (t "account.subscription.address_banner.title"))
      }}
      class="u--m__t__0"
    >
      <p>
        {{t "account.subscription.address_banner.description"}}
        <LinkTo @route="subscription.billing.edit" class="u--text--underline">
          {{t "account.subscription.address_banner.cta"}}
        </LinkTo>
      </p>
    </Shared::CollapsableInfoCard>
  {{/if}}
  */
  {
    "id": "Fc6C+m9D",
    "block": "[[[41,[30,0,[\"showAddressBanner\"]],[[[1,\"  \"],[8,[39,1],[[24,0,\"u--m__t__0\"]],[[\"@title\"],[[28,[37,2],[[28,[37,3],[\"<span class=\\\"u--text--md u--p__r__xs\\\">⚠️</span>\",[28,[37,4],[\"account.subscription.address_banner.title\"],null]],null]],null]]],[[\"default\"],[[[[1,\"\\n    \"],[10,2],[12],[1,\"\\n      \"],[1,[28,[35,4],[\"account.subscription.address_banner.description\"],null]],[1,\"\\n      \"],[8,[39,5],[[24,0,\"u--text--underline\"]],[[\"@route\"],[\"subscription.billing.edit\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,4],[\"account.subscription.address_banner.cta\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[],false,[\"if\",\"shared/collapsable-info-card\",\"html-safe\",\"concat\",\"t\",\"link-to\"]]",
    "moduleName": "settings/components/address-banner.hbs",
    "isStrictMode": false
  });

  let AddressBannerComponent = (_class = class AddressBannerComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "address", _descriptor, this);
    }

    get showAddressBanner() {
      return this.address.showAddressBanner;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = AddressBannerComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AddressBannerComponent);
});